export const GET_QUICKLINKS_REQUEST = "get_quicklinks_request";
export const GET_QUICKLINKS_SUCCESS = "get_quicklinks_success";
export const GET_QUICKLINKS_FAILURE = "get_quicklinks_failure";

export const GET_EXTERNAL_SITE_MESSAGE_REQUEST = "get_external_site_message_request";
export const GET_EXTERNAL_SITE_MESSAGE_SUCCESS = "get_external_site_message_success";
export const GET_EXTERNAL_SITE_MESSAGE_FAILURE = "get_external_site_message_failure";

export const SHOW_EXTERNAL_CONFIRMATION_MODAL = "show_external_confirmation_modal";
